import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/insurance-partners-banner.png';
import '../styles/pages.css';

function InsurancePartners() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Insurance Partners</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Streamlining healthcare access with trusted insurance 
                            <br/> 
                            partnerships at Caritas Matha Hospital.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Streamlining healthcare access with trusted insurance partnerships at Caritas Matha Hospital.
                        </p>
                    </div>

                    <div className="page-box">
                        <div className="box-content">
                            <p>Caritas Matha Hospital collaborates with a diverse network of insurance partners to ensure comprehensive coverage and seamless healthcare access for our patients. We work closely with leading insurance providers to facilitate hassle-free billing processes and support patients in navigating their insurance benefits effectively.</p>
                        </div>
                        <div className="box-image">
                            <img src={BannerImage} alt="Clinical Nutrition" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">
                <div className='page-content'>
                    <p className='page-content-heading'>
                        Quality Care Meets Comprehensive Coverage
                        <br />
                        at Caritas Matha Hospital
                    </p>
                    <br />
                    <div className='page-details'>
                        <p>Caritas Matha Hospital is proud to offer comprehensive healthcare coverage through our extensive network of partnerships with leading healthcare insurance providers. Our network includes prominent private companies and key public sector stakeholders, ensuring that you have access to a wide range of healthcare services.</p>
                        <br />
                        
                        <p>As a valued beneficiary of Caritas insurance, you not only benefit from our extensive network but also have the opportunity to leverage advantages outlined in Section 17(2) of the Income Tax Act. This reflects our commitment to your health and well-being.</p>
                        <br />

                        <p>We have established strategic partnerships with various Insurance and Third-Party Administrator (TPA) companies, further demonstrating our dedication to providing comprehensive healthcare solutions. These partnerships underscore our commitment to prioritizing your health and ensuring peace of mind.</p>
                        <br />

                        <h6>For More Information : </h6>
                        <br />

                        <p>Phone: <a href='tel:+91 9446 021 300'>+91 9446 021 300</a></p>
                        <p>Email: <a href='mailto:insurance.caritashsp@gmail.com'>insurance.caritashsp@gmail.com</a></p>          
                        <br />

                        <p>At Caritas Matha Hospital, we strive to deliver quality care with comprehensive coverage, ensuring that your healthcare needs are met with professionalism and compassion.</p>
                        <br />
                    </div>
                </div>

                <div className="more-services">
                    <p className="more-services-heading">More Services</p>
                    <div className='more-services-links'>
                        <a href="/radiology-laboratory"><p> Radiology & Laboratory</p></a>
                        <a href="/blood-bank"><p> Blood Bank</p></a>
                        <a href="/clinical-nutrition"><p> Clinical Nutrition</p></a>
                        <a href="/caritas-mortuary-services"><p> Caritas Mortuary Services</p></a>
                        <a href="/pastoral-care"><p> Pastoral Care</p></a>
                        <a href="/caritas-home-care"><p> Caritas Home Care</p></a>
                        <a href="https://www.caritashospital.org/health-checkup-packages"><p> Health Checkup Packages</p></a>
                        <a href="/video-consultation"><p> Video Consultation</p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default InsurancePartners;